/**
 * Chart theme that switches to print-safe colours during PDF snapshot capture.
 */
import { useEffect, useState } from "react";
import {
	chartTheme,
	getActiveChartTheme,
	isPrintCaptureActive,
	type ChartTheme,
} from "./chartTheme";

export const PRINT_CAPTURE_EVENT = "flaha-print-capture";

export function useChartTheme(): ChartTheme {
	const [theme, setTheme] = useState<ChartTheme>(() => getActiveChartTheme());

	useEffect(() => {
		const sync = () => setTheme(getActiveChartTheme());
		window.addEventListener(PRINT_CAPTURE_EVENT, sync);
		// Also poll attribute briefly if event is missed
		const mo = new MutationObserver(sync);
		mo.observe(document.documentElement, {
			attributes: true,
			attributeFilter: ["data-print-capture"],
		});
		return () => {
			window.removeEventListener(PRINT_CAPTURE_EVENT, sync);
			mo.disconnect();
		};
	}, []);

	return theme;
}

export { chartTheme, isPrintCaptureActive };
